





















import { UseModal } from "@/components/root/modal";
import { computed } from "@vue/composition-api";
import Vue from "vue";
import {
  GeneratorReportTemplateSection,
  ReportTemplateSection,
  TemplateGeneratorHelper,
} from "../data/pdf/model";
import PreviewA4ModalVue from "./PreviewA4Modal.vue";
export default Vue.extend({
  props: ["sections"],
  setup(props) {
    const expend = async (section: ReportTemplateSection) => {
      UseModal().show(PreviewA4ModalVue, {
        type: "single",
        img: section.runtime.a4_img,
      });
    };

    const display_section = computed(() =>
      TemplateGeneratorHelper.spread_sections(
        props.sections as GeneratorReportTemplateSection[]
      )
    );

    return {
      expend,
      display_section,
    };
  },
});
